/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import * as firebase from "firebase";
import Api from '../generated'
import vSelect from 'vue-select'
import VueMaterial from 'vue-material'
import config from './config'
import VueLocalStorage from 'vue-localstorage'
import SmoothPicker from 'vue-smooth-picker'

require('vue-material/dist/vue-material.css')
require('./css/flexboxgrid.css')
require('vue-smooth-picker/dist/css/style.css')
//require('./css/bootstrap.min.css')
require('./css/global.css')

Vue.use(VueResource);
Vue.use(VueMaterial);
Vue.use(VueLocalStorage);
Vue.use(SmoothPicker);
Vue.component('v-select', vSelect)

Api.ApiClient.instance = new Api.DefaultApi();
//Api.ApiClient.instance.apiClient.basePath = "http://localhost:3000/api";

Vue.material.registerTheme('default', {
	primary: 'deep-purple',
	accent: 'blue',
	warn: 'red'
})

firebase.initializeApp(config.firebaseConfig[Vue.localStorage.get('project', config.default)]);

router.beforeEach((to, from, next) => {
	firebase.auth().onAuthStateChanged((user) => {
		if(user || to.name === "login" || !to.path.startsWith("/admin")){
			next();	
		}else{
			next('/');
		}		
	});
});

const app = new Vue({
	router,
	...App
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js